import * as React from 'react';
const chatLayoutPaneKind = Symbol.for('mui.x.chat.layout-pane-kind');
export function markChatLayoutPane(component, kind) {
  component[chatLayoutPaneKind] = kind;
  return component;
}
export function getChatLayoutPaneKind(element) {
  if (! /*#__PURE__*/React.isValidElement(element)) {
    return null;
  }

  // Primary: symbol-based detection (works for direct unstyled components)
  const symbolKind = element.type[chatLayoutPaneKind];
  if (symbolKind === 'conversations' || symbolKind === 'thread') {
    return symbolKind;
  }

  // Fallback: explicit pane prop (works for wrapped components like React.memo, styled, etc.)
  const paneKind = element.props?.pane;
  if (paneKind === 'conversations' || paneKind === 'thread') {
    return paneKind;
  }
  return null;
}